import { Observable } from 'rxjs';
import { DatosPersonalesRequest } from '../interfaces/datos-personales-request';
import { GeneralResponse } from '../interfaces/general-response';

export abstract class DatosSociosService {

  abstract validaCi(rut: number, ci: string): Observable<GeneralResponse<any>>;
  abstract validaCiPendiente(rut: number, ci: string): Observable<GeneralResponse<any>>;
  abstract getDatosPersonales(run: number): Observable<any>;
  abstract registraDatosPersonales(datosPersonales: DatosPersonalesRequest): Observable<any>;
  abstract getSociosRegistrados(): Observable<any>;
  abstract eliminarRegistro(run: number): Observable<any>;
  abstract getSociosEmpresa(): Observable<any>;
}
